import { createContext, useContext } from 'react';

export const DataContext = createContext(null);
export const AppContext = createContext(null);

export const useData = () => useContext(DataContext);
export const useApp = () => useContext(AppContext);
